// THIS FILE IS GENERATED DO NOT EDIT
// To regenerate run `npm run themes:prep`
import absaImport from "./absa.js";
import iemasImport from "./iemas.js";
import oldmutualImport from "./oldmutual.js";
import oobaImport from "./ooba.js";
import rmlImport from "./rml.js";
import simplyImport from "./simply.js";
export var themeIds = ["absa", "iemas", "oldmutual", "ooba", "rml", "simply"];
export var absa = absaImport;
export var iemas = iemasImport;
export var oldmutual = oldmutualImport;
export var ooba = oobaImport;
export var rml = rmlImport;
export var simply = simplyImport;